module.exports = __webpack_public_path__ + "img/user.7675b598.svg";